import ChatArchiveDialog from './ChatArchiveDialog';

export default ChatArchiveDialog;
